import { render, staticRenderFns } from "./FullScreenSetting.vue?vue&type=template&id=3b1b257f&"
import script from "./FullScreenSetting.vue?vue&type=script&lang=js&"
export * from "./FullScreenSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports